import { render, staticRenderFns } from "./SourceChart.vue?vue&type=template&id=c6523db2&scoped=true&"
import script from "./SourceChart.vue?vue&type=script&lang=js&"
export * from "./SourceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6523db2",
  null
  
)

export default component.exports